import React from 'react'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

const NumberFormat: React.FC<NumericFormatProps> = (props) => {
  return (
    <NumericFormat
      displayType="text"
      decimalSeparator=","
      thousandSeparator="."
      {...props}
    />
  )
}

export default NumberFormat
